var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { getImageObject } from '../../adapters/get-image-object';
export var IDs = {
    SD_JSON_IMAGES: 'images-component.structured-data.images',
};
var SchemaTypes = {
    IMAGES_COMPONENT: 'images-component-preset',
};
var userVisible = [];
var getStructuredData = function (IDs, item) {
    var _a;
    var _b;
    if (!IDs) {
        return {};
    }
    var imagesData = (_b = item === null || item === void 0 ? void 0 : item.images) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
        var imageURL = _a.url, width = _a.width, height = _a.height, altText = _a.altText;
        return ({
            url: imageURL,
            width: width,
            height: height,
            name: altText,
        });
    }).filter(function (image) { return !!image.url; });
    var _c = getImageObject('images', imagesData).images, images = _c === void 0 ? '' : _c;
    return _a = {},
        _a[IDs.SD_JSON_IMAGES] = images || [],
        _a;
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        return __assign({}, getStructuredData(IDs, item));
    },
    getSdStatus: function () { return SD_STATUS.ENABLED; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
};
